import styled from 'styled-components'

export const Layout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(280px, 1fr);
  gap: 24px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Form = styled.form`
  width: 100%;
  /* display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto auto; */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;

  .lg {
    width: 100%;
  }

  .md {
    width: calc(50% - 5px);
  }

  grid-template-areas:
    'header header'
    'left   right';

  .header {
    grid-area: header;
  }

  .left {
    grid-area: left;
  }

  .right {
    grid-area: right;
  }
`
export const FieldRow = styled.div`
  display: grid;
  grid-template-rows: minmax(0, 1fr);
  grid-template-columns: minmax(0, 1fr);
  column-gap: 10px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const DoubleColContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
`
